import { Button, MenuItem } from "@mui/material";

import { useSetup } from "../../SetupLife.context";

import { BenefitsPolicyVigencyType, IBenefitsPolicy, IBenefitsPolicyRegion, IBenefitsPolicyUnique } from "../../SetupLife.types";
import { ButtonDelete, Row, SelectForm, Title } from "./BenefitsPolicy.styled";

import { locationOptions } from "v2/pages/MissingDataFormulary/MissingDataMultistep/helper";

interface IProps {
  benefitsPolicy: IBenefitsPolicy;
  handleChange: (payload: Partial<IBenefitsPolicy>) => void;
}

export function BenefitsPolicyUnique({ benefitsPolicy, handleChange }: IProps) {
  const { setup } = useSetup();

  /** Opções possíveis da coluna de Plano. */
  const planOptions: string[] = [];

  function handleUpdateUnique(payload: Partial<IBenefitsPolicyUnique>) {
    handleChange({ 
      ...benefitsPolicy, 
      benefitsPolicyByUnique: { 
        ...benefitsPolicy.benefitsPolicyByUnique, 
        ...payload 
      } 
    });
  }

  return (
    <>
      <Title>Negociação</Title>
      <Row style={{ alignItems: "center"}}>
        <SelectForm
          label="Negociação"
          value={benefitsPolicy?.benefitsPolicyByUnique?.plan}
          onChange={(e) => handleUpdateUnique({ plan: e.target.value as string })}
        >
          {benefitsPolicy.negotiations.map(negotiation => (
            <MenuItem key={negotiation} value={negotiation} disabled={benefitsPolicy.benefitsPolicyByUnique.plan === negotiation}>{negotiation}</MenuItem>
          ))}
        </SelectForm>
      </Row>
    </>
  );
}
